import React from "react";
import propTypes from "prop-types";
import {
  FormControl,
  FormGroup,
  FormLabel,
  Grid,
  Checkbox as MCheckBox,
  FormControlLabel,
} from "@material-ui/core";

const CheckBox = ({
  name,
  label,
  checked,
  onChange,
  className,
  labelPlacement,
  // case Formik's select
  field,
  form: { touched: toucheds, errors, setFieldValue },
  isFormik,
  ...props
}) => (
  <FormControl component="fieldset">
    <FormGroup>
      <Grid component="label" container alignItems="center" spacing={1}>
        <Grid item>
          <FormControlLabel
            labelPlacement={labelPlacement}
            label={label}
            control={
              <MCheckBox
                {...field}
                {...props}
                name={name}
                className={className}
                checked={isFormik ? field.value : checked}
                onChange={e => {
                  isFormik && setFieldValue(field.name, e.target.checked);
                  onChange && onChange(e);
                }}
                value={name}
              />
            }
          />
        </Grid>
      </Grid>
    </FormGroup>
  </FormControl>
);

CheckBox.propTypes = {
  className: propTypes.string,
  name: propTypes.string,
  checked: propTypes.bool,
  onChange: propTypes.func,
  labelPlacement: propTypes.string,
  // case Formik's select
  field: propTypes.any,
  form: propTypes.shape({
    touched: propTypes.any,
    errors: propTypes.any,
    setFieldValue: propTypes.func,
  }),
  isFormik: propTypes.bool,
};

CheckBox.defaultProps = {
  className: "",
  onChange: () => {},
  name: "",
  labelPlacement: "end",
  checked: null,
  field: null,
  form: {},
  isFormik: false,
};

export default CheckBox;
